package navigation.home.invoice.addeditinvoice

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.quickbooks.domain.QuickbooksClient
import com.essntl.core.stripe.domain.StripeClient
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.category.domain.repository.CategoryRepository
import com.essntl.features.client.domain.repository.ClientRepository
import com.essntl.features.invoice.domain.repository.InvoiceRepository
import com.essntl.features.invoice.ui.addeditinvoice.AddEditInvoiceEvent
import com.essntl.features.invoice.ui.addeditinvoice.AddEditInvoiceState
import com.essntl.features.invoice.ui.addeditinvoice.AddEditInvoiceViewModel
import com.essntl.features.invoice.ui.addeditinvoice.AddEditInvoiceValidation
import com.essntl.features.itinerary.domain.repository.ItineraryRepository
import com.essntl.features.paymentlink.domain.repository.PaymentLinkRepository
import com.essntl.features.paymentparameter.domain.repository.PaymentParameterRepository
import com.essntl.features.proposal.domain.repository.ProposalRepository
import com.essntl.features.service.domain.repository.ServiceRepository
import com.essntl.features.travelagent.domain.repository.TravelAgentRepository
import com.essntl.toastmanager.ToastManager

class AddEditInvoiceScreenModel(
    invoiceRepository: InvoiceRepository,
    categoryRepository: CategoryRepository,
    serviceRepository: ServiceRepository,
    paymentLinkRepository: PaymentLinkRepository,
    proposalRepository: ProposalRepository,
    itineraryRepository: ItineraryRepository,
    clientRepository: ClientRepository,
    travelAgentRepository: TravelAgentRepository,
    paymentParameterRepository: PaymentParameterRepository,
    quickbooksClient: QuickbooksClient,
    stripeClient: StripeClient,
    toastManager: ToastManager,
    loadingManager: LoadingManager,
) : StateScreenModel<AddEditInvoiceState>(AddEditInvoiceState()) {
    val validation = AddEditInvoiceValidation()

    val vm = AddEditInvoiceViewModel(
        invoiceRepository = invoiceRepository,
        categoryRepository = categoryRepository,
        serviceRepository = serviceRepository,
        paymentLinkRepository = paymentLinkRepository,
        proposalRepository = proposalRepository,
        itineraryRepository = itineraryRepository,
        clientRepository = clientRepository,
        travelAgentRepository = travelAgentRepository,
        paymentParameterRepository = paymentParameterRepository,
        quickbooksClient = quickbooksClient,
        stripeClient = stripeClient,
        toastManager = toastManager,
        loadingManager = loadingManager,
        scope = screenModelScope,
        state = mutableState,
    )

    fun onEvent(event: AddEditInvoiceEvent) = vm.onEvent(event)
}